/**
 * model representing an Organization score for location-about, disaster-about
 */

export interface OrgDisasterScore {
  organizationName: string;
  organizationId: number;
  disasterName: string;
  updateScore: number;
  adminEditScore: number;
  directServiceScore: number;
  refusedQuestionScore: number;
  localStaffScore: number;
  localStaffCountScore: number;
}

export interface OrgLocationScore {
  organizationName: string;
  organizationId: number;
  countryName: string;
  countryId: number;
  updateScore: number;
  adminEditScore: number;
  directServiceScore: number;
  refusedQuestionScore: number;
  localStaffScore: number;
}
